"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7812],{

/***/ 44305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowLeft2; }
/* harmony export */ });
/* harmony import */ var _rollupPluginBabelHelpers_3bc641ae_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19599);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43493);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);




var _excluded = ["variant", "color", "size"];

var Bold = function Bold(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M13.978 5.319l-3.21 3.21-1.97 1.96a2.13 2.13 0 000 3.01l5.18 5.18c.68.68 1.84.19 1.84-.76V6.079c0-.96-1.16-1.44-1.84-.76z"
  }));
};

var Broken = function Broken(_ref2) {
  var color = _ref2.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.19 7.94l-2.62 2.62c-.77.77-.77 2.03 0 2.8l6.52 6.52M15.09 4.04l-1.04 1.04"
  }));
};

var Bulk = function Bulk(_ref3) {
  var color = _ref3.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M10.77 8.52l5.05 3.79v5.61c0 .96-1.16 1.44-1.84.76L8.8 13.51a2.13 2.13 0 010-3.01l1.97-1.98z",
    opacity: ".4"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M15.82 6.08v6.23l-5.05-3.79 3.21-3.21c.68-.67 1.84-.19 1.84.77z"
  }));
};

var Linear = function Linear(_ref4) {
  var color = _ref4.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 19.92L8.48 13.4c-.77-.77-.77-2.03 0-2.8L15 4.08"
  }));
};

var Outline = function Outline(_ref5) {
  var color = _ref5.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: color,
    d: "M15 20.67c-.19 0-.38-.07-.53-.22l-6.52-6.52a2.74 2.74 0 010-3.86l6.52-6.52c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-6.52 6.52c-.48.48-.48 1.26 0 1.74l6.52 6.52c.29.29.29.77 0 1.06-.15.14-.34.22-.53.22z"
  }));
};

var TwoTone = function TwoTone(_ref6) {
  var color = _ref6.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 19.92L8.48 13.4c-.77-.77-.77-2.03 0-2.8L15 4.08"
  }));
};

var chooseVariant = function chooseVariant(variant, color) {
  switch (variant) {
    case 'Bold':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Bold, {
        color: color
      });

    case 'Broken':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Broken, {
        color: color
      });

    case 'Bulk':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Bulk, {
        color: color
      });

    case 'Linear':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Linear, {
        color: color
      });

    case 'Outline':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Outline, {
        color: color
      });

    case 'TwoTone':
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(TwoTone, {
        color: color
      });

    default:
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Linear, {
        color: color
      });
  }
};

var ArrowLeft2 = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref7, ref) {
  var variant = _ref7.variant,
      color = _ref7.color,
      size = _ref7.size,
      rest = (0,_rollupPluginBabelHelpers_3bc641ae_js__WEBPACK_IMPORTED_MODULE_1__._)(_ref7, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_rollupPluginBabelHelpers_3bc641ae_js__WEBPACK_IMPORTED_MODULE_1__.a)({}, rest, {
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }), chooseVariant(variant, color));
});
ArrowLeft2.propTypes = {
  variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['Linear', 'Bold', 'Broken', 'Bulk', 'Outline', 'TwoTone']),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)])
};
ArrowLeft2.defaultProps = {
  variant: 'Linear',
  color: 'currentColor',
  size: '24'
};
ArrowLeft2.displayName = 'ArrowLeft2';




/***/ }),

/***/ 94266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ _objectWithoutProperties; },
/* harmony export */   "a": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}




/***/ }),

/***/ 21844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KG": function() { return /* binding */ getImageList; },
/* harmony export */   "Si": function() { return /* binding */ getBranchesFilters; },
/* harmony export */   "Yr": function() { return /* binding */ getInstallments; },
/* harmony export */   "fA": function() { return /* binding */ getSimilarStores; },
/* harmony export */   "fH": function() { return /* binding */ getWidgets; },
/* harmony export */   "hA": function() { return /* binding */ getBranchesList; },
/* harmony export */   "oU": function() { return /* binding */ getStoreItems; }
/* harmony export */ });
var getStoreItems = function(state) {
    var ref;
    return (ref = state.stores) === null || ref === void 0 ? void 0 : ref.storeItems;
};
var getSimilarStores = function(state) {
    var ref;
    return (ref = state.stores) === null || ref === void 0 ? void 0 : ref.similarStores;
};
var getBranchesList = function(state) {
    var ref;
    return (ref = state.stores) === null || ref === void 0 ? void 0 : ref.branchesList;
};
var getBranchesFilters = function(state) {
    var ref, ref1;
    return (ref = state.stores) === null || ref === void 0 ? void 0 : (ref1 = ref.branchesList) === null || ref1 === void 0 ? void 0 : ref1.ApplyFilter;
};
var getImageList = function(state) {
    var ref, ref1;
    return (ref = state.stores) === null || ref === void 0 ? void 0 : (ref1 = ref.storeItems) === null || ref1 === void 0 ? void 0 : ref1.ImageList;
};
var getWidgets = function(state) {
    var ref;
    return (state === null || state === void 0 ? void 0 : (ref = state.stores) === null || ref === void 0 ? void 0 : ref.widgets) || [];
};
var getInstallments = function(state) {
    var ref;
    return state === null || state === void 0 ? void 0 : (ref = state.stores) === null || ref === void 0 ? void 0 : ref.installment;
};



/***/ }),

/***/ 27812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81663);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74237);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81253);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41464);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38092);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92021);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96528);
/* harmony import */ var iconsax_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(44305);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60107);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83944);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19599);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8072);
/* harmony import */ var constants_endPoint__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36933);
/* harmony import */ var provider_Store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16926);
/* harmony import */ var redux_settings_reducer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66126);
/* harmony import */ var redux_stores_selectors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21844);
/* harmony import */ var screen_Stores_Skeleton_WidgetsLoading__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22519);
/* harmony import */ var utility_baseURL__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(95877);
/* harmony import */ var utility_decodeURL__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17542);
















var Wallet = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 4860).then(__webpack_require__.bind(__webpack_require__, 64860));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64860)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
});
var SwiperKit = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9619), __webpack_require__.e(2977), __webpack_require__.e(1274)]).then(__webpack_require__.bind(__webpack_require__, 28600));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28600)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
});
var LinkKit = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7108), __webpack_require__.e(8682)]).then(__webpack_require__.bind(__webpack_require__, 32079));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32079)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
});
var SquareStoreItem = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6701), __webpack_require__.e(4293), __webpack_require__.e(2732), __webpack_require__.e(1394), __webpack_require__.e(9052)]).then(__webpack_require__.bind(__webpack_require__, 91394));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91394)
            ];
        }
    },
    suspense: true
});
var CategoriesBox = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7733).then(__webpack_require__.bind(__webpack_require__, 49905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49905)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
});
var ButtonKit = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.lazy(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6701), __webpack_require__.e(4923), __webpack_require__.e(5610)]).then(__webpack_require__.bind(__webpack_require__, 36551)).then(function(module) {
        return {
            default: module.ButtonKit
        };
    });
});
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
    return {
        wrapperStoreTitle: {
            color: theme.palette.text.dark
        },
        parentSlider: {
            width: "100%",
            position: "relative",
            paddingRight: "1.6rem"
        },
        childrenSlider: {
            position: "relative",
            width: "100%"
        }
    };
});
var WidgetsMobile = function() {
    var classes = useStyles();
    var widgetList = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(redux_stores_selectors__WEBPACK_IMPORTED_MODULE_10__/* .getWidgets */ .fH) || [];
    var skeleton = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(redux_settings_reducer__WEBPACK_IMPORTED_MODULE_7__/* .getSettingsLoading */ .dx).skeleton;
    var theme = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    var Router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var state = react__WEBPACK_IMPORTED_MODULE_3__.useContext(provider_Store__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).state;
    var handleMoveTo = function(widget) {
        var ref;
        var currentCategoryID = (ref = widget === null || widget === void 0 ? void 0 : widget.find(function(item) {
            return item;
        })) === null || ref === void 0 ? void 0 : ref.CategoryID;
        Router.push({
            pathname: constants_endPoint__WEBPACK_IMPORTED_MODULE_5__/* .paths["/search"] */ .H["/search"],
            query: (0,utility_decodeURL__WEBPACK_IMPORTED_MODULE_12__/* .decodeQueryStrings */ .d)({
                "CurrentCategoryIds[0]": currentCategoryID,
                "app_keepa": state.app_keepa,
                sponsor_id: state.sponsor_id
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
        container: true,
        spacing: skeleton && !(widgetList === null || widgetList === void 0 ? void 0 : widgetList.length) ? 0 : 2,
        children: [
            skeleton && (widgetList === null || widgetList === void 0 ? void 0 : widgetList.length) === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(screen_Stores_Skeleton_WidgetsLoading__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            !skeleton && react__WEBPACK_IMPORTED_MODULE_3__.Children.toArray(widgetList.map(function(widget, index) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        !state.app_keepa && index === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                            xs: 12,
                            item: true,
                            mt: "8.8rem",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wallet, {})
                            })
                        }),
                        widget.WidgetTypeName !== "Banner" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                            xs: 12,
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    className: "element-center",
                                    mt: "5.6rem",
                                    flexDirection: "column",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            variant: "h4",
                                            fontWeight: 700,
                                            className: classes.wrapperStoreTitle,
                                            children: widget.Title
                                        }),
                                        [
                                            "Category",
                                            "SupplierCart"
                                        ].includes(widget === null || widget === void 0 ? void 0 : widget.WidgetTypeName) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            variant: "subtitle1",
                                            fontWeight: 700,
                                            mt: "0.8rem",
                                            color: theme.palette.text.secondary,
                                            children: widget.Subtitle
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                            xs: 12,
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                                    container: true,
                                    spacing: 2,
                                    children: widget.Items.slice(0, 4).map(function(item) {
                                        var ref, ref1;
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                widget.WidgetTypeName === "SupplierCart" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                                                    xs: 6,
                                                    item: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
                                                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            width: "100%",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                sx: {
                                                                    bgcolor: theme.palette.primary[300],
                                                                    borderRadius: "1.2rem"
                                                                },
                                                                height: 250,
                                                                width: "100%",
                                                                variant: "rounded",
                                                                animation: "wave"
                                                            })
                                                        }),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            component: LinkKit,
                                                            href: "/stores/".concat((item === null || item === void 0 ? void 0 : item.SupplierID) || "/").concat(state.app_keepa ? "/?app_keepa=true&sponsor_id=".concat(state.sponsor_id) : ""),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SquareStoreItem, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, item))
                                                        })
                                                    })
                                                }, item.id),
                                                widget.WidgetTypeName === "Banner" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                                                    xs: 12,
                                                    item: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkKit, {
                                                        href: ((ref = item.Link) === null || ref === void 0 ? void 0 : ref.includes("http")) ? item.Link : "".concat(constants_endPoint__WEBPACK_IMPORTED_MODULE_5__/* .paths["/stores"] */ .H["/stores"], "/").concat(item.Link).concat(state.app_keepa ? "/?app_keepa=true&sponsor_id=".concat(state.sponsor_id) : ""),
                                                        target: ((ref1 = item.Link) === null || ref1 === void 0 ? void 0 : ref1.includes("http")) ? "_blank" : "_self",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            style: {
                                                                position: "relative",
                                                                borderRadius: theme.shape.medium,
                                                                overflow: "hidden",
                                                                marginTop: "0.8rem",
                                                                height: "auto"
                                                            },
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "".concat((0,utility_baseURL__WEBPACK_IMPORTED_MODULE_19__/* .getOldBaseURL */ .v3)()).concat(item.Image),
                                                                loading: "lazy",
                                                                alt: widget.Title,
                                                                placeholder: "blur",
                                                                // objectFit="contain"
                                                                style: {
                                                                    width: "100%",
                                                                    height: "auto",
                                                                    borderRadius: theme.shape.medium
                                                                }
                                                            })
                                                        })
                                                    })
                                                }, widget.DefaultOffset)
                                            ]
                                        });
                                    })
                                })
                            })
                        }),
                        widget.WidgetTypeName === "Category" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                            xs: 12,
                            item: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                disableGutters: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    className: classes.parentSlider,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwiperKit, {
                                        data: (widget === null || widget === void 0 ? void 0 : widget.Items) || [],
                                        innerProps: {
                                            direction: "horizontal",
                                            loop: true,
                                            slidesPerView: 3,
                                            spaceBetween: 120
                                        },
                                        proMode: true,
                                        rootClassName: classes.childrenSlider,
                                        children: widget === null || widget === void 0 ? void 0 : widget.Items.map(function(category) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                onClick: function() {
                                                    return Router.push({
                                                        pathname: constants_endPoint__WEBPACK_IMPORTED_MODULE_5__/* .paths["/search"] */ .H["/search"],
                                                        query: (0,utility_decodeURL__WEBPACK_IMPORTED_MODULE_12__/* .decodeQueryStrings */ .d)({
                                                            "CurrentCategoryIds[0]": category === null || category === void 0 ? void 0 : category.CategoryID,
                                                            "app_keepa": state.app_keepa,
                                                            sponsor_id: state.sponsor_id
                                                        })
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoriesBox, {
                                                    image: category === null || category === void 0 ? void 0 : category.Images,
                                                    Name: category === null || category === void 0 ? void 0 : category.Name,
                                                    size: "",
                                                    Id: category === null || category === void 0 ? void 0 : category.CategoryID
                                                }, category === null || category === void 0 ? void 0 : category.Name)
                                            }, category.Name);
                                        })
                                    })
                                })
                            })
                        }),
                        ![
                            "Banner",
                            "Category"
                        ].includes(widget.WidgetTypeName) && (widget === null || widget === void 0 ? void 0 : widget.DefaultOffset) > 4 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                            xs: 12,
                            item: true,
                            mt: "2.4rem",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Suspense, {
                                    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonKit, {
                                        variant: "outlined",
                                        fullWidth: true,
                                        endLoading: true,
                                        style: {
                                            padding: "1.55rem"
                                        },
                                        endIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(iconsax_react__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            size: 18,
                                            color: theme.palette.text.hint,
                                            style: {
                                                marginRight: "1.6rem"
                                            }
                                        }),
                                        onClick: function() {
                                            return handleMoveTo(widget.Items);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            variant: "subtitle1",
                                            color: theme.palette.text.dark,
                                            children: "مشاهده فروشگاه بیشتر"
                                        })
                                    })
                                })
                            })
                        })
                    ]
                });
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WidgetsMobile);


/***/ })

}]);